export const METADATA_TYPE = {
  STRING: "STRING",
  BOOLEAN: "BOOLEAN",
  STRING_ARRAY: "STRING_ARRAY",
} as const

export type MetadataType = (typeof METADATA_TYPE)[keyof typeof METADATA_TYPE]
